import configService from "@/services/config";

const { theme } = configService;

/**
 * @description Carga el asset de logo de un theme. Intenta SVG; si el theme
 * tiene su logo en PNG (ej. deragopyan, vilella), cae a PNG.
 * @param {string} logoName - Nombre base del archivo en `@/assets/logos/`
 * @returns {string|null} URL del asset, o null si no existe
 */
const loadLogo = (logoName) => {
  try {
    // deragopyan usa PNG; el resto de los temas, SVG.
    if (theme === "deragopyan") {
      return require(`@/assets/logos/${logoName}.png`);
    }
    return require(`@/assets/logos/${logoName}.svg`);
  } catch (e) {
    // Fallback a PNG — hay temas (ej. vilella) cuyo logo viene en PNG.
    try {
      return require(`@/assets/logos/${logoName}.png`);
    } catch (e2) {
      return null;
    }
  }
};

const logoUrl = loadLogo(theme);
const logoAltUrl = loadLogo(`${theme}-alt`);

export default {
  data() {
    return {
      logoUrl,
      logoAltUrl,
      theme,
    };
  },
};
